"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadesCarousel = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const navigation = {
  size: 'small',
  position: 'outside'
};
const pagination = {
  show: false
};
const slider = {
  loop: false,
  mode: 'free',
  slides: {
    perView: 'auto',
    spacing: _constants.SPACING
  }
};
const ShadesCarousel = ({
  currentShade,
  setCurrentShadeProductCode,
  shades,
  id
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const onShadeClick = (0, _react.useCallback)(shadeCode => () => {
    const url = new URL(window.location.href);
    url.searchParams.set('code', shadeCode);
    window.history.replaceState(null, '', url.toString());
    setCurrentShadeProductCode?.(shadeCode);
  }, [setCurrentShadeProductCode]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CarouselComponent, {
    hasFocusableSlides: true,
    navigation: navigation,
    pagination: pagination,
    slider: slider,
    id: id,
    testId: getTestId(_constants.SHADES_AND_DETAILS_CAROUSEL),
    children: shades.map(({
      productCode,
      canBeSold,
      hexColors,
      imageUrl,
      name
    }, index) => {
      const isLast = index === shades.length - 1;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledCarouselSlide, {
        minWidth: _presentationComponents.SHADES_SIZE_CURRENT + (isLast ? 5 : 0),
        index: index,
        isLast: isLast,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledShade, {
          shade: {
            productCode,
            canBeSold,
            hexColors,
            imageUrl,
            name
          },
          isCurrent: productCode === currentShade.productCode,
          currentShade: currentShade,
          testId: getTestId(_constants.SHADES_AND_DETAILS_SHADE),
          onShadeClick: onShadeClick(productCode)
        })
      }, productCode);
    })
  });
};
exports.ShadesCarousel = ShadesCarousel;
